export default "__VITE_ASSET__DKT5adcv__"